export default __webpack_public_path__ + "static/media/favorites-barre.9aebb7a3.png";